import { createContext as e, useContext as t } from "react";
// src/components/data-table/table-context.ts
var n = e({
	size: "md",
	variant: "default"
}), r = n.Provider, i = () => t(n);
export { r as TableProvider, i as useTableContextSafe };

//# sourceMappingURL=table-context.js.map